module.exports = __webpack_public_path__ + "img/products-3.0853dad5.jpg";